import React, {useState} from 'react';
import info from '../../assets/images/info-1.svg';
import {toast} from "react-toastify";
import toastOptions from "../../data/ToastOptions";
import checkModalTaskValidation from "./validationOnSubmitModal";
import close from '../../assets/images/closeWhite.svg';
import * as TasksApi from "../../api/tasks";
import copy from '../../assets/images/copy-white.svg';
import shareOrEarn from '../../assets/images/ShareEarn.jpg';
import {copyToClipboard} from "../GlobalFunctions";

const ModalTask = ({item, onClose}) => {
    const fileInputRef = React.useRef(null);
    const [selectedFile, setSelectedFile] = useState(null);
    const [preview, setPreview] = useState("");
    const [link, setLink] = useState("");
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);
    const [show, setShow] = useState('');

    const handleButtonClick = () => {
        fileInputRef.current.click();
    };

    const handleFileChange = (event) => {
        const file = event.target.files[0];
        const maxSize = 3 * 1024 * 1024;

        if (file) {
            if (file.size > maxSize) {
                toast.error('The image size must not exceed 3MB', {...toastOptions, toastId: 37})
            } else {
                delete errors['img'];
                setSelectedFile(file);
                const reader = new FileReader();
                reader.onloadend = () => {
                    setPreview(reader.result);
                };
                reader.readAsDataURL(file);
            }
        }
    };

    const onSubmit = () => {
        const data = {
            task_id: item?.id,
            img: selectedFile,
            link,
            modal_data: item?.modal_data,
        }
        checkModalTaskValidation(data)
            .then(response => {
                if (Object.entries(response).length < 1) {
                    sendDataFn();
                } else {
                    setErrors(response);
                }
            })
    }

    const sendDataFn = () => {
        setLoading(true);
        const data = {
            task_id: item?.id,
            img: selectedFile,
            link,
        }
        TasksApi.sendModalData(data)
            .then(response => {
                setLoading(false);
                if (response.data.status === '1') {
                    toast.success('Submitted Successfully!', {...toastOptions, toastId: 35})
                    onClose('withSubmit')
                } else {
                    if (response.data.msg === 'LIMIT_FILE_SIZE') {
                        toast.error('The image size must not exceed 3MB', {...toastOptions, toastId: 38})
                    } else if (response.data.msg === 'INVALID_FILE_TYPE') {
                        toast.error('The image format is not supported', {...toastOptions, toastId: 39})
                    } else {
                        toast.error('Something went wrong! Please try again', {...toastOptions, toastId: 34})
                    }
                }
            })
            .catch((e) => {
                toast.error('Something went wrong! Please try again', {...toastOptions, toastId: 30})
            })
    }

    const changeLink = (e) => {
        delete errors['link']
        setLink(e.target.value)
    }

    const removeImageFn = () => {
        setSelectedFile(null);
        setPreview(null);
    }

    const copyFn = () => {
        copyToClipboard(item?.modal_data?.proof)
        // navigator.clipboard.writeText(item?.modal_data?.proof)
        // toast.success('Text Copied.', {...toastOptions, toastId: 36});
    }

    const state1 = item?.modal_data?.proof;
    const state3 = item?.modal_data?.task_status && item?.modal_data?.task_status !== 'NOTHING';
    const state4 = (item?.modal_data?.task_status && item?.modal_data?.task_status === 'NOTHING') || (item?.modal_data?.task_status && item?.modal_data?.task_status === 'REJECTED') || !item?.modal_data?.task_status;

    return (
        <div className="tasks-modalTaskContainer">
            <img alt="Jace Tasks" src={shareOrEarn} className="tasks-modalTaskImage" />
            <p className="text-white fs18 font-bold mt30">Description:</p>
            <p className="text-white fs16 ml10 text-left mt5 preline">{item?.modal_data?.description}</p>
            <p className="text-white fs18 font-bold mt30">Note:</p>
            <p className="text-white fs16 ml10 text-left mt5 preline">
                You must include the unique string (provided below) within your post content to verify authenticity.
            </p>
            {state1 && <button type="button" className="w100 tasks-linkBtn mt20" onClick={copyFn}>
                <span className="text-gray1 fs16 text-left mt5 pr10 lineNumber1 preline">
                    {item?.modal_data?.proof}
                </span>
                <img alt="copy" className="tasks-icon1 mlAuto mr0" src={copy}/>
            </button>}
            {state4 && item?.modal_data?.is_link_required && <div className="tasks-linkContainer w100 wrap">
                <div className="center relative tooltip-wrapper">
                    {show === 'link' && <div className="tooltip-box">
                        <p className="text-left text-black fs16 font-bold">Post Link (Required)</p>
                        <p className="text-left text-black fs16 mt5">Share the direct link to your post.</p>
                    </div>}
                    <img
                        alt="Jace Tasks"
                        src={info} className="tasks-icon1"
                        onMouseEnter={() => setShow('link')}
                        onMouseLeave={() => setShow('')}/>
                    <p className="text-white fs16 nowrap minW120">Share Link</p>
                </div>
                <div className="flex1 start minW120Custom maxW400 column mt10">
                    <input type="text" className="w100 tasks-input" onChange={changeLink}/>
                    {errors['link'] && <p className="fs14 text-red">{errors['link']}</p>}
                </div>
            </div>}
            {state4 && item?.modal_data?.is_img_required && <div className="tasks-imageSelectorContainer w100 wrap mt20">
                <div className="start relative tooltip-wrapper">
                    {show === 'image' && <div className="tooltip-box">
                        <p className="text-left text-black fs16 font-bold">Screenshot (Required)</p>
                        <p className="text-left text-black fs16 mt5">Upload a clear screenshot of your post, ensuring the unique string is visible in the caption.</p>
                    </div>}
                    <img
                        alt="Jace Tasks"
                        src={info} className="tasks-icon1"
                        onMouseEnter={() => setShow('image')}
                        onMouseLeave={() => setShow('')}/>
                    <p className="text-white fs16 nowrap minW120">Upload Image</p>
                </div>
                {!preview && <div className="center alignStart column mt10 minW225">
                    <button
                        onClick={handleButtonClick}
                        className="tasks-selectImageBtn"
                    >
                        <span className="fs16 text-gray1 nowrap">Select Image</span>
                    </button>
                    <input
                        type="file"
                        ref={fileInputRef}
                        className="tasks-selectImageInput"
                        accept="image/*"
                        onChange={handleFileChange}
                    />
                    {errors['img'] && <p className="fs14 text-red">{errors['img']}</p>}
                </div>}
                {preview && (
                    <div className="mt20 column start">
                        <div className="relative ml20 center border1">
                            <img
                                src={preview}
                                alt="preview"
                                className="tasks-imagePreview"
                            />
                            <button type="button" className="tasks-removeBtn pointer" onClick={removeImageFn}>
                                <img alt="remove" src={close} className="tasks-closeIcon"/>
                            </button>
                        </div>
                    </div>
                )}
            </div>}
            {state3 && <div className="start column">
                <p className="fs16 font-bold text-white mt30">Status:</p>
                <p className={`fs16 font-bold mt10 ${item?.modal_data?.task_status === 'UNDER_REVIEW' ? 'text-orange' : item?.modal_data?.task_status === 'ACCEPTED' ? 'text-green' : 'text-red'}`}>{`Your Proof is "${item?.modal_data?.task_status}"`}</p>
            </div>}
            {state4 && <button
                onClick={onSubmit}
                className={`tasks-submitBtn ${state4 ? 'mt60' : 'mt10'}`}
            >
                {!loading && <span className="fs16 text-black">Submit</span>}
                {loading && <div className="loader"></div>}
            </button>}
            <button
                onClick={onClose}
                className={`tasks-submitBtn tasks-closeBtn ${!state4 ? 'mt60' : 'mt10'}`}
            >
                <span className="fs16 text-gray1">Close</span>
            </button>
        </div>
    );
}

export default ModalTask;
